<form [formGroup]="findingInvestorsForm" class="finding-investors-form">
  <div class="form-section">
    <div class="form-grid">
      <div class="form-group full-width">
        <span class="group-label required"
          >Do you know what type of investor you are looking for?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="investorYes"
              type="radio"
              formControlName="knowInvestorType"
              value="yes"
            />
            <label for="investorYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="investorNo"
              type="radio"
              formControlName="knowInvestorType"
              value="no"
            />
            <label for="investorNo">No</label>
          </div>
          <div class="radio-item">
            <input
              id="investorNeedHelp"
              type="radio"
              formControlName="knowInvestorType"
              value="need_help"
            />
            <label for="investorNeedHelp"
              >I need investors but need help deciding</label
            >
          </div>
          <div class="radio-item">
            <input
              id="investorStartup"
              type="radio"
              formControlName="knowInvestorType"
              value="learn_more"
            />
            <label for="investorStartup"
              >I’m a startup and want to explore options in the region</label
            >
          </div>
        </div>
        @if (
          findingInvestorsForm.get("knowInvestorType")?.touched &&
          findingInvestorsForm.get("knowInvestorType")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }

        @if (findingInvestorsForm.get("knowInvestorType")?.value === "yes") {
          <div class="investment-types-section">
            <fieldset>
              <legend class="investment-legend required">
                What type of investment are you looking for?
              </legend>
              <div class="checkbox-list" formGroupName="investmentTypes">
                @for (type of investmentTypes; track type) {
                  <div class="checkbox-item">
                    <input
                      [id]="'investment_' + sanitizeKey(type)"
                      type="checkbox"
                      [formControlName]="sanitizeKey(type)"
                    />
                    <label [for]="'investment_' + sanitizeKey(type)">{{
                      type
                    }}</label>
                  </div>
                }
              </div>
              @if (
                findingInvestorsForm.get("investmentTypes")?.touched &&
                findingInvestorsForm.get("investmentTypes")?.invalid
              ) {
                <span class="error-message"
                  >Please select at least one investment type</span
                >
              }
            </fieldset>
          </div>
        }
      </div>

      <div class="form-group full-width">
        <span class="group-label required"
          >Are you willing to move to a new geography to potentially receive
          investment?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="relocateYes"
              type="radio"
              formControlName="willingToRelocate"
              value="yes"
            />
            <label for="relocateYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="relocateNo"
              type="radio"
              formControlName="willingToRelocate"
              value="no"
            />
            <label for="relocateNo">No</label>
          </div>
          <div class="radio-item">
            <input
              id="relocateDepends"
              type="radio"
              formControlName="willingToRelocate"
              value="depends"
            />
            <label for="relocateDepends">Depends</label>
          </div>
        </div>
        @if (
          findingInvestorsForm.get("willingToRelocate")?.touched &&
          findingInvestorsForm.get("willingToRelocate")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>
    </div>
  </div>
</form>
